import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

class KnowledgeBaseHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { t } = this.props;
    const activeClassName = 'active';

    return (
      <div className="setting_header">
        <div className="setting_header_inner">
          <div className="setting_header_box">
            <nav className="setting_lnb">
              <NavLink
                to="/knowledge_base/component"
                className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}
              >
                {t('knowledgebase.vuln_component')}
              </NavLink>
              <NavLink
                to="/knowledge_base/cve"
                className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}
              >
                {t('knowledgebase.vuln_cve')}
              </NavLink>
            </nav>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(KnowledgeBaseHeader);
